import { useMutation } from '@apollo/client';
import React from 'react';
import TextInput from '../../../components/input';
import ModalFormComp from '../../../components/ModalFormComp';
import useForm from '../../../customHooks/useForm';
import useToast from '../../../customHooks/useToast';
import { APPROVE_LOAN_PENDING_AUTHORIZATION } from '../../../graphql/admin_mutations';
import ConfirmDeactivationIcon from '../../../svgs/ConfirmDeactivationIcon';

interface IDeclineLoanModal{
  closeModal?:any;
  loanId?:string;
  handlegetAllCaLoans?:any;
}
const DeclineLoanModal = ({ closeModal, loanId, handlegetAllCaLoans }:IDeclineLoanModal) => {
  const Toast = useToast();
  const [decline, { loading: declineLoading }] = useMutation<
  { approveLoanPendingAuthorization: any },
  any
>(APPROVE_LOAN_PENDING_AUTHORIZATION);
  const {
    formValues, handleChange, resetForm,
  } = useForm(
    {
      reason: '',
    },
    {},
    Toast,
  );
  const handleConfirmActivation = async () => {
    if (formValues?.reason === '') {
      Toast.error('all field required.');
      return;
    }
    if (!declineLoading) {
      try {
        const res = await decline({
          variables: { id: loanId, approve: false },
        });

        resetForm({
          reason: '',
        });

        if (
          res?.data?.approveLoanPendingAuthorization
          && res?.data?.approveLoanPendingAuthorization?.status === 200) {
          Toast.success(res?.data?.approveLoanPendingAuthorization?.message || 'Operation was successful');
          handlegetAllCaLoans();
          closeModal();
        } else {
          Toast.error(res?.data?.approveLoanPendingAuthorization?.message || 'Operation failed');
        }
      } catch (e) {
        resetForm({
          reason: '',
        });
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
    }
  };

  return (
    <div>
      <ModalFormComp confirmationBtnContent={declineLoading ? 'Declining...' : 'Decline'} closeModal={closeModal} removeTitle modalType="admin-confirmation-modal" confirmActionBtn={handleConfirmActivation} btnLoading={declineLoading} confirmationIcon={<ConfirmDeactivationIcon />} confirmationSubTitle="Provide a reason for declining loan account below" confirmationTitle="Decline Loan">
        <div>
          <TextInput rows={3} name="reason" value={formValues?.reason} multiline placeholder="Reason for declining" customOnChange={handleChange} />
        </div>
      </ModalFormComp>

    </div>
  );
};
export default DeclineLoanModal;
